export default __webpack_public_path__ + "static/media/coincaII.d1f0fba5.jpg";